import { IconType } from '@/types';

export default function SignInIcon({ className, width = 24, height = 24 }: IconType) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M11.875 6.33333V4.75C11.875 4.33007 11.7082 3.92734 11.4112 3.63041C11.1143 3.33348 10.7116 3.16666 10.2917 3.16666H4.75C4.33007 3.16666 3.92734 3.33348 3.63041 3.63041C3.33348 3.92734 3.16666 4.33007 3.16666 4.75V14.25C3.16666 14.6699 3.33348 15.0727 3.63041 15.3696C3.92734 15.6665 4.33007 15.8333 4.75 15.8333H10.2917C10.7116 15.8333 11.1143 15.6665 11.4112 15.3696C11.7082 15.0727 11.875 14.6699 11.875 14.25V12.6667'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.625 9.5H6.33333M6.33333 9.5L8.70833 7.125M6.33333 9.5L8.70833 11.875'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
